(() => {
  if (window.wrNativeFiltersReady) return;
  window.wrNativeFiltersReady = true;
  const initialized = new WeakSet();
  function scan(scope = document) {
    scope.querySelectorAll('.plush-native-filters').forEach(form => {
      if (initialized.has(form)) return;
      initialized.add(form);
      const details = [...form.querySelectorAll('details')];
      details.forEach(item => item.addEventListener('toggle', () => {
        if (item.open) details.forEach(other => { if (other !== item) other.open = false; });
      }));
      form.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const opened = details.find(item => item.open);
          if (opened) { opened.open = false; opened.querySelector('summary').focus(); }
        }
        const menu = event.target.closest('.plush-sort-menu');
        if (!menu || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        menu.open = true;
        const options = [...menu.querySelectorAll('[data-sort-value]')];
        const index = options.indexOf(document.activeElement);
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : event.key === 'ArrowDown' ? (index + 1) % options.length : (index < 0 ? options.length - 1 : (index + options.length - 1) % options.length);
        options[target]?.focus();
      });
      const select = form.querySelector('[name="sort_by"]');
      const menu = form.querySelector('.plush-sort-menu');
      if (!select || !menu) return;
      select.hidden = true;
      menu.hidden = false;
      const sync = () => {
        menu.querySelector('[data-sort-label]').textContent = select.selectedOptions[0]?.textContent || '';
        menu.querySelectorAll('[data-sort-value]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sortValue === select.value)));
        menu.open = false;
      };
      sync();
      select.addEventListener('change', () => { sync(); form.requestSubmit(); });
      menu.addEventListener('click', event => {
        const option = event.target.closest('[data-sort-value]');
        if (!option) return;
        select.value = option.dataset.sortValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('click', event => {
    document.querySelectorAll('.plush-native-filters details[open]').forEach(item => {
      if (!item.contains(event.target)) item.open = false;
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
})();
